import { useState } from 'react';
import Axios from '../utils/axios';

function Login() {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const authenticate = async () => {
		const body = new FormData();
		body.append('username', username);
		body.append('password', password);
		const res = await Axios.post('auth/token', body, {
			'Content-Type': 'application/x-www-form-urlencoded'
		});

		const { access_token, role } = res.data;
		await localStorage.setItem('token', access_token);
		await localStorage.setItem('role', role);

		window.location.href = '/';
	};

	return (
		<div className="grid h-screen grid-cols-4 grid-rows-3 transition-all duration-500 bg-gradient-to-tr from-cyan-900 via-cyan-600 to-cyan-400">
			<div className="col-span-2 col-start-2 row-start-2 p-4 rounded-lg shadow-xl bg-cyan-900">
				<h1 className="text-center text-white">لطفا اطلاعات خود را وارد کنید.</h1>
				<TextField state={username} setState={setUsername} label="نام کاربری" />
				<TextField
					state={password}
					setState={setPassword}
					type="password"
					label="رمز عبور"
					onKeyPress={async (e) => {
						if (e.key === 'Enter') {
							await authenticate();
						}
					}}
				/>
				<div className="grid justify-around grid-cols-3 ">
					<button
						className="col-start-2 p-2 px-8 ml-auto bg-teal-400 rounded shadow-2xl"
						onClick={async () => await authenticate()}
					>
						ورود
					</button>
				</div>
			</div>
		</div>
	);
}

function TextField(props) {
	const { state, setState, label, type, ...etc } = props;
	return (
		<div className="md:my-0">
			<input
				key={label}
				className="w-full p-2 m-2 placeholder-gray-500 rounded shadow placeholder-opacity-900 "
				type={type || 'text'}
				placeholder={label}
				value={state}
				onChange={(e) => setState(e.target.value)}
				{...etc}
			/>
		</div>
	);
}
export default Login;
